import React, { FC, useEffect, useMemo, useState } from 'react';
import InputWrapper from '../InputWrapper/InputWrapper';
import { TextField as MuiTextField } from '@mui/material';
import styles from './TextField.module.scss';

export interface TextFieldProps {
  label: string;
  onChange: (value: string) => void;
  required?: boolean;
}

const TextField: FC<TextFieldProps> = ({ label, onChange, required }) => {
  const [value, setValue] = useState<string>('');
  const [touched, setTouched] = useState<boolean>(false);
  const [focused, setFocused] = useState<boolean>(false);

  const error = useMemo(() => touched && !focused && required && !value, [required, value, touched, focused]);

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <InputWrapper label={label}>
      <MuiTextField
        className={styles.textField + (error ? ' ' + styles.error : '')}
        variant="outlined"
        color="secondary"
        onChange={e => setValue(e.target.value)}
        onBlur={() => setFocused(false)}
        onFocus={() => {
          setTouched(true);
          setFocused(true);
        }}
      />
    </InputWrapper>
  );
};

export default TextField;
